import type { ORPCClient, Outputs } from '@/lib/orpc'
import { Button } from '@/components/ui/button'
import { DialogTrigger } from '@/components/ui/dialog'
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle
} from '@/components/ui/item'
import { Key, Pencil } from 'lucide-react'

import RotateApiKeyModal from './rotate-api-key-modal'

export default function ApiKeyItem({
  apiKey,
  orpc
}: {
  apiKey: Outputs['backoffice']['apiKeys']['getAll'][number]
  orpc: ORPCClient
}) {
  return (
    <RotateApiKeyModal apiKey={apiKey} orpc={orpc}>
      <Item variant="outline">
        <ItemMedia>
          <Key />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>{apiKey.name}</ItemTitle>
          <ItemDescription className="italic">
            Diperbarui pada{' '}
            {new Date(apiKey.updatedAt).toLocaleDateString('id-ID', {
              day: '2-digit',
              month: 'long',
              year: 'numeric'
            })}
            .
          </ItemDescription>
        </ItemContent>
        <ItemActions>
          <DialogTrigger asChild>
            <Button variant="outline" size="icon">
              <Pencil />
            </Button>
          </DialogTrigger>
        </ItemActions>
      </Item>
    </RotateApiKeyModal>
  )
}
